


































import Component from 'vue-class-component';
import {mixins} from 'vue-class-component/lib/util';
import {Prop, Watch} from 'vue-property-decorator';
import OptionsBasedComponent from '../../../mixins/options-based-component';
import Button from './button.vue';

@Component({
  name: 'DCheckboxGroup',
  components: {
    ACheckboxGroup: window.antd.Checkbox.Group,
    DCheckboxButton: Button,
    ACheckbox: window.antd.Checkbox
  }
})
export default class DCheckboxGroup extends mixins(OptionsBasedComponent) {

  /**
   * 是否使用按钮样式
   */
  @Prop({type: Boolean, default: false})
  public button: boolean;
  @Prop({type: String, default: ''})
  public checkboxClass: string;
  /**
   * 单个选项的样式
   */
  @Prop({type: Object, default: () => ({})})
  public checkboxStyle: object;

  @Watch('value')
  public valueChanged(value: any) {
    if (this.stateValue !== this.convertValue(value)) {
      this.stateValue = this.convertValue(value) || [];
    }
  }

  get customProps() {
    const props: any = {};
    const thisProps = this['props'];
    Object.keys(thisProps).forEach(key => {
      if (key !== 'options') {
        props[key] = thisProps[key];
      }
    });
    return props;
  }

}
